import React, { FC, useMemo } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'

const ProgramPageAbout: FC<{ text: string | null }> = (props) => {
  const { text } = props

  const newText = useMemo(() => {
    const jsonText = JSON.stringify(text)

    /** вместо \n подставляем </br> */
    const htmlText = jsonText.replace(/\\n/gm, '</br>')

    return JSON.parse(htmlText)
  }, [text])

  return (
    <div>
      <Heading h2='О программе' spacing='small' />

      {text && <Text>{newText}</Text>}
    </div>
  )
}

export default ProgramPageAbout
